module.exports = __webpack_public_path__ + "static/media/jingpinjiagebiao.6560f475.png";